import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getCurrentDate } from '../../../../../helpers/Common';

import { downloadScore, downloadCanSlim } from '../../reducer';
import ExportBlob from '../../../../../common/export-blob';

class ExportCommon extends React.Component {
  handleExport = () => {
    const API_PARAMS = {
      'strategy.vis': {
        params: 'Value',
        fileName: I18n.t('common.export.strategy.value', {
          date: getCurrentDate(),
        }),
        reducerName: 'ST_VALUE',
      },
      'strategy.gis': {
        params: 'Growth',
        fileName: I18n.t('common.export.strategy.growth', {
          date: getCurrentDate(),
        }),
        reducerName: 'ST_GROWTH',
      },
      'strategy.mis': {
        params: 'Momentum',
        fileName: I18n.t('common.export.strategy.momentum', {
          date: getCurrentDate(),
        }),
        reducerName: 'ST_MOMENTUM',
      },
      'strategy.vmg': {
        params: 'VGM',
        fileName: I18n.t('common.export.strategy.vgm', {
          date: getCurrentDate(),
        }),
        reducerName: 'ST_VGM',
      },
      'strategy.lis': {
        params: 'Leaders',
        fileName: I18n.t('common.export.strategy.leaders', {
          date: getCurrentDate(),
        }),
        reducerName: 'ST_LEADER',
      },
      CANSLIM: {},
    };

    const { downloadScore, downloadCanSlim, title } = this.props;
    if (title === 'CANSLIM')
      return downloadCanSlim(
        I18n.t('common.export.strategy.canSlim', { date: getCurrentDate() }),
      );
    const { params, fileName, reducerName } = API_PARAMS[title];
    downloadScore(params, reducerName, fileName);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => {
  return { i18n: state.i18n };
};

const mapDispatchToProps = {
  downloadScore,
  downloadCanSlim,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
